export default {
  path: '/gifs',
  name: 'gifs',
  component: () => import('../components/gif/Layout'),
  redirect: { name: 'GifList' },
  meta: {
    breadcrumb: 'gifs',
  },
  children: [
    {
      name: 'GifList',
      path: '',
      component: () => import('../views/gif/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'GifCreate',
      path: 'new',
      component: () => import('../views/gif/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'GifShow',
      path: ':id',
      component: () => import('../views/gif/Show'),
      meta: {
        breadcrumb: 'gif',
      },
    }
  ]
};
